<template>
  <label v-if="label" :for="id">
    {{ label }}<span v-if="required" class="text-danger ml-1">*</span>
  </label>
</template>

<script>
export default {
  name: 'FLabel',
  props: {
    label: String,
    id: String,
    required: Boolean
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormFields/Base/FLabel.vue